import store from "@/store";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyC6U4lwHQrPbOrSvntM7w253DjcQpYfgp0",
  authDomain: "journeybinder.firebaseapp.com",
  databaseURL: "https://journeybinder.firebaseio.com",
  projectId: "journeybinder",
  storageBucket: "journeybinder.appspot.com",
  messagingSenderId: "667044535329",
  appId: "1:667044535329:web:f72305490edd122c511760",
  measurementId: "G-ZGMN3YFK6L"
});

firebase.analytics();

export default {
  install: (Vue, options) => {
    const auth = firebaseApp.auth();

    auth.onAuthStateChanged(user => {
      store.commit("user/UPDATE_USER", { user });
      if (user) store.dispatch("user/getUserDeviceRegistrationToken");
    });
  }
};
